import { render } from "./TableItem.vue?vue&type=template&id=f9b5007c&scoped=true&ts=true"
import script from "./TableItem.vue?vue&type=script&lang=ts"
export * from "./TableItem.vue?vue&type=script&lang=ts"

import "./TableItem.vue?vue&type=style&index=0&id=f9b5007c&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9b5007c"]])

export default __exports__